import React, { useEffect, useState } from "react";
import { getComments } from "../../services/commentService";
import CommentItem from "./CommentItem";
import CommentForm from "./CommentForm";
import { CommentDto, CommentLikeStatus } from "../../types/comment";

interface CommentListProps {
  photoId: number;
}

const CommentList: React.FC<CommentListProps> = ({ photoId }) => {
  const [comments, setComments] = useState<CommentDto[]>([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalCount, setTotalCount] = useState(0);

  const loadComments = async (page = 1) => {
    try {
      const result = await getComments(photoId, page, 3);
      setComments(result.items || []);
      setTotalPages(result.totalPage || 1);
      setTotalCount(result.totalCount || 0);
      setCurrentPage(page);
    } catch (error) {
      console.error("Failed to load comments:", error);
      setComments([]);
      setTotalCount(0);
    }
  };


  useEffect(() => {
    loadComments();
  }, [photoId]);

  const handleToggleLike = (commentId: number, newStatus: CommentLikeStatus) => {
    const updatedComments = comments.map((comment) =>
      comment.commentId === commentId
        ? { ...comment, isLikedByCurrentUser: newStatus.liked, likeCount: newStatus.likeCount }
        : comment
    );
    setComments(updatedComments);
  };


  return (
    <>
      <CommentForm photoId={photoId} onCommentAdded={() => loadComments(currentPage)} />
      <div className="space-y-4">
        {(comments ?? []).map((comment) => (
          <CommentItem
            key={comment.commentId}
            comment={comment}
            onLikeToggle={handleToggleLike}
          />
        ))}
      </div>

      <div className="flex items-center justify-center mt-4 w-full max-w-md mx-auto">
        {totalCount === 0 ? (
          <span className="text-xs  text-accentAlt">No comments yet</span>
        ) : totalPages > 1 ? (
          <div className="flex items-center justify-between w-full">
            <button
              className={`custom-btn ${currentPage === 1 ? 'opacity-50 cursor-not-allowed' : ''}`}
              onClick={() => loadComments(Math.max(1, currentPage - 1))}
              disabled={currentPage === 1}
            >
              Prev
            </button>

            <span className="text-xs  text-accentAlt text-center flex-1">
              Showing <strong>{(currentPage - 1) * 3 + 1}</strong> - <strong>{Math.min(currentPage * 3, totalCount)}</strong> of <strong>{totalCount}</strong>
            </span>

            <button
              className={`custom-btn ${currentPage === totalPages ? 'opacity-50 cursor-not-allowed' : ''}`}
              onClick={() => loadComments(Math.min(totalPages, currentPage + 1))}
              disabled={currentPage === totalPages}
            >
              Next
            </button>
          </div>
        ) : (
          <span className="text-xs text-accentAlt">
            Showing all <strong>{totalCount}</strong> comment{totalCount > 1 ? 's' : ''}
          </span>
        )}
      </div>

    </>
  );
};

export default CommentList;
